module.exports = __webpack_public_path__ + "img/huangpujunxiao.bcb7af49.png";